<p-table 
    #table
    [loading]="loading" 
    [value]="subappalti" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm" 
    [paginator]="false" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    [globalFilterFields]="['ragione_sociale', 'piva']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} subappalti" 
    [rows]="50" [rowsPerPageOptions]="[5, 10, 20, 50]">            
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">                                   
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca subappalto…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">                    
                <button class="flex-1 acc-btn" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi
                </button>
                <button class="flex-1 acc-btn" type="button" (click)="onDownloadDocumenti()">                
                    <i class="bi bi-file-zip-fill"></i>
                    Scarica
                </button>
            </div>
        </div>  
    </ng-template>
    <ng-template pTemplate="header">
        <tr>                            
            <th pSortableColumn="ragione_sociale">Ragione Sociale <span class="inline-flex"><p-sortIcon field="ragione_sociale" /></span></th>
            <th pSortableColumn="piva">P.Iva / CF <span class="inline-flex"><p-sortIcon field="piva" /></span></th>
            <th pSortableColumn="visura_camerale">Visura <span class="inline-flex"><p-sortIcon field="visura_camerale" /></span></th>                
            <th pSortableColumn="pos">POS o dichiarazione sostitutiva <span class="inline-flex"><p-sortIcon field="pos" /></span></th>                
            <th class="text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-subappalto let-expanded="expanded">
        <tr>            
            <td>
                <span class="p-column-title">Ragione Sociale</span>
                <span class="cell-nome">{{subappalto.ragione_sociale}}</span>
            </td>
            <td>
                <span class="p-column-title">P.Iva / Codice Fiscale</span>
                <span class="cell-meta" style="margin:0;font-size:12px">{{subappalto.piva}}</span>
            </td>
            <td>
                <span class="p-column-title">Visura Camerale</span>
                @if (subappalto.visura_camerale) {
                    <a class="mini-pill ok" [href]="subappalto.visura_camerale + '?type=documento' | file" target="_blank" rel="noopener noreferrer">scarica</a>
                } @else {
                    <span class="mini-pill crit">mancante</span>
                }
            </td>
            <td>
                <span class="p-column-title">POS o dichiarazione sostitutiva</span>
                @if (subappalto.pos) {
                    <a class="mini-pill ok" [href]="subappalto.pos + '?type=documento' | file" target="_blank" rel="noopener noreferrer">scarica</a>
                } @else {
                    <span class="mini-pill crit">mancante</span>
                }
            </td>
            <td class="text-center">
                <span class="p-column-title">Azioni</span>
                <div class="table-actions">                    
                    <i class="bi bi-pencil" (click)="onOpenEdit(subappalto)" title="Modifica"></i>
                    <p-divider layout="vertical"></p-divider>
                    <p-confirmPopup #delete>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onClose()">Annulla</button>
                                    <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()">Elimina</button>                                            
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <i class="bi bi-trash" (click)="onOpenDelete($event, subappalto)" title="Elimina"></i>
                </div>
            </td>
        </tr>
    </ng-template>        
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6">Nessun subappaltatore trovato.</td>
        </tr>
    </ng-template>
</p-table>

<app-add-subappalto-accrediti-backoffice [visible]="add" [evento]="evento" (close)="add = false" />
<app-edit-subappalto-accrediti-backoffice *ngIf="subappalto" [visible]="edit" [subappalto]="subappalto" (close)="onCloseEdit($event)" />

<app-loading-backoffice [visible]="loading"></app-loading-backoffice>